export default __webpack_public_path__ + "static/media/rote_patrona_full.12bcb772.png";